import React, { useRef, useState } from 'react'
import { navigate } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Container, Col, Row, Form } from 'react-bootstrap'
import TinySlider from 'tiny-slider-react'
import SearchInput from '../../SearchInput'
import Link from '../../Link'

import {
	heroWrapper,
	slideImage,
	prevNextWrapper,
	slideLabelWrapper,
	label,
	title,
	heroContent,
	contentWrapper,
	sliderContainer,
	sliderWrapper,
	heroSearch,
} from './HeroSlider.module.scss'

const HeroSliderInner = ({ ...props }) => {
	if (typeof window === 'undefined') {
		return null
	}
	const settings = {
		lazyload: false,
		nav: false,
		loop: true,
		autoplay: false,
		controls: false,
		items: 1,
		container: '.hero-slider',
		mode: "gallery"
	}

	const slideLabels = props?.slides?.map(slide => ({
		title: slide.title,
		label: slide.label,
	}))

	const [currentLabel, setCurrentLabel] = useState(slideLabels[0])

	const elementRef = useRef()

	const handleDirection = dir => {
		elementRef.current.slider.goTo(dir)
		const currentInfo = elementRef.current.slider.getInfo()
		setCurrentLabel(slideLabels[currentInfo.displayIndex - 1])
	}

	const handleSubmit = e => {
		e.preventDefault()
		const searchParams = new URLSearchParams(new FormData(e.target)).toString()
		navigate(`/search/?${searchParams}`)
	}

	const HeroSearchForm = () => (
		<Form onSubmit={handleSubmit}>
			<input type="hidden" name="post_type[]" value="pro_service" />
			<SearchInput
				iconSize="sm"
				placeholderText="Search services and sectors"
				ariaLabel="Search services and sectors"
			/>
		</Form>
	)

	return (
		<div className={heroWrapper}>
			<Container fluid="lg">
				<Row>
					<Col className="p-0" xs={12} md={7} lg={8}>
						<div className={sliderWrapper}>
							<div className={[sliderContainer, 'hero-slider'].join(' ')}>
								<TinySlider settings={settings} ref={elementRef}>
									{props?.slides?.map((item, index) => {
                    const link = item.slideLink?.uri;
                    
										return (
											<Link key={`${item.slideImage?.id}${index}`} to={link}>
												<GatsbyImage
													alt={item.slideImage?.altText !== '' ? item.slideImage?.altText : item.label}
													image={
														item.slideImage?.localFile?.childImageSharp
															.gatsbyImageData
													}
													className={slideImage}
												/>
											</Link>
										)
									})}
								</TinySlider>
							</div>
							<div className={prevNextWrapper}>
								<span className={slideLabelWrapper}>
									<span className={title}>{currentLabel.title}</span>
									<span className={label}>{currentLabel.label}</span>
								</span>

								<button type="button" onClick={() => handleDirection('prev')}>
									<i className="ss-icon ss-left ss-black-tie-bold" />
									<span className="sr-only">Previous</span>
								</button>
								<button type="button" onClick={() => handleDirection('next')}>
									<i className="ss-icon ss-right ss-black-tie-bold" />
									<span className="sr-only">Next</span>
								</button>
							</div>
						</div>
					</Col>
					<Col className="p-0 p-md-4" xs={12} md={5} lg={4}>
						<div className={contentWrapper}>
							<h1
								className="title--xl"
								dangerouslySetInnerHTML={{ __html: props.headline }}
							/>

							<div
								dangerouslySetInnerHTML={{ __html: props.content }}
								className={['editor-section', heroContent].join(' ')}
							/>

							{props.search && (
								<div className={heroSearch}>
									<HeroSearchForm />
								</div>
							)}
						</div>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

export default HeroSliderInner
